import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/")({
  loader: () => {
    throw redirect({
      to: "./profile/details",
      from: "/gym/$venueUuid/loyalty/quests/$questUuid/",
      replace: true,
    });
  },
});
